import { Project } from "./projects.model";
import { Commercial } from "./commercials.model";
import { Customer } from "./customers.model";

export class Decision {
	id: number;
	name: string;
	createAt: Date;
	decideAt: Date;
	done: boolean;
	project: Project;
	commercial: Commercial;
	customer: Customer;

	constructor() { 
		this.project = new Project();
		this.commercial = new Commercial();
		this.customer = new Customer();
	}
}

export class DecisionForm {
	id: number;
	name: string;
	createAt: Date;
	decideAt: Date;
	done: boolean;
	project: number;
	commercial: number;
	customer: number;

	constructor() { }
}